import { render, staticRenderFns } from "./trajectory.vue?vue&type=template&id=be872cb0&scoped=true&"
import script from "./trajectory.vue?vue&type=script&lang=js&"
export * from "./trajectory.vue?vue&type=script&lang=js&"
import style0 from "./trajectory.vue?vue&type=style&index=0&id=be872cb0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be872cb0",
  null
  
)

export default component.exports